module.exports = __webpack_public_path__ + "img/invalid.fe670e4c.png";